import {
    madnes_tween_bezier,
    madnes_tween_catmull,
    madnes_tween_from,
    madnes_tween_func,
    madnes_tween_pause,
    madnes_tween_resume,
    madnes_tween_start,
    madnes_tween_stop,
    madnes_tween_to
} from "../../../framework/src/engine/madnes/madnes_tween";
import {MadnesGroup} from "./MadnesGroup";
import {MadnesObject} from "./MadnesObject";

/**
 * @constructor
 * @returns {MadnesTween}
 */
export default function MadnesTween() {
    /** @type {*} */
    this.tween;
};

/**
 *
 * @param {string} name
 * @returns {Function}
 */
MadnesTween.getEasing = function(name) {
    return madnes_tween_func(name);
};

MadnesTween.prototype.getEasing = function(name) {
    return MadnesTween.getEasing(name);
};

/**
 * @param {String|Object|MadnesObject|MadnesGroup|MadnesGraphics} obj
 * @param {Object} settings
 * @param {Object} props
 * @returns {MadnesTween}
 */
MadnesTween.prototype.to = function(obj, settings, props) {

    if(obj instanceof MadnesObject || obj instanceof MadnesGroup) {
        obj = obj.name;
    }

    this.tween = madnes_tween_to(obj, settings, props);
    return this;
};

/**
 * @param {String|Object|MadnesObject|MadnesGroup|MadnesGraphics} obj
 * @param {Object} settings
 * @param {Object} props
 * @returns {MadnesTween}
 */
MadnesTween.prototype.from = function(obj, settings, props) {

    if(obj instanceof MadnesObject || obj instanceof MadnesGroup) {
        obj = obj.name;
    }

    this.tween = madnes_tween_from(obj, settings, props);
    return this;
};

/**
 * @returns {MadnesTween}
 */
MadnesTween.prototype.bezier = function() {
    madnes_tween_bezier(this.tween);
    return this;
};

/**
 * @returns {MadnesTween}
 */
MadnesTween.prototype.catmull = function() {
    madnes_tween_catmull(this.tween);
    return this;
};

/**
 * @returns {MadnesTween}
 */
MadnesTween.prototype.start = function() {
    madnes_tween_start(this.tween);
    return this;
};

/**
 * @returns {MadnesTween}
 */
MadnesTween.prototype.stop = function() {
    madnes_tween_stop(this.tween);
    return this;
};

/**
 * @returns {MadnesTween}
 */
MadnesTween.prototype.pause = function() {
    madnes_tween_pause(this.tween);
    return this;
};

/**
 * @returns {MadnesTween}
 */
MadnesTween.prototype.resume = function() {
    madnes_tween_resume(this.tween);
    return this;
};

MadnesTween.prototype.destroy = function() {
    this.tween && this.stop();
    this.tween = null;
};